export const MLB_PRIVACY_POLICY_URL = 'https://www.mlb.com/official-information/privacy-policy';

export const MLB_INTEGRATION_ID = 1;
